// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d700f8a9","301":"73e0e1c2","389":"40ed4da0","732":"0b3756fa","977":"0c9a6992"}[chunkId] + ".chunk.js";
};